import { render, staticRenderFns } from "./TaskManage.vue?vue&type=template&id=7667bdd8"
import script from "./TaskManage.vue?vue&type=script&lang=js"
export * from "./TaskManage.vue?vue&type=script&lang=js"
import style0 from "./TaskManage.vue?vue&type=style&index=0&id=7667bdd8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports